import type { FaireProductEntity } from "../../entity_types/product";

export const p_tnyj5qm5nt: FaireProductEntity = {
  token: "p_tnyj5qm5nt",
  type: "product",
  name: "Rose Hibiscus Glow - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/e824c5228e3e0319a3a9f5b8c06a7add9a1fd9b06151d93a6a5fad8747b2d7bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c08ff7bcd97032bb9a73fb85a48bde2c30049bd98e4236c8c212d342ef8d5194.png",
    "https://cdn.faire.com/fastly/8e06eb889e9c3dca7ce3686e5d0982bd489312440019a8d9bb776ca3c5888e30.jpeg"
  ],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND\n\nBoost beauty from the inside-out with this hydrating blend that’s dripping with hibiscus, rosehip & ripe citrus. With a ruby red tint and fruity feel, it’s like a plant-powered, adaptogenic kool-aid in your mug.\n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a drizzle of honey. \n * Delicious iced or cold-brewed with a squeeze of lime and drizzle of maple syrup. \nWhen to Steep:\n\n\n * A nourishing all day caffeine-free tea \n * To hydrate, boost and protect your skin. \n * To boost your immunity with superfoods. \n * Iced as a refreshing summer tonic\n\nCaffeine-free\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:40.514Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
